import { Description } from '../Description'

import { Wrapper, Cards, Card, TableTitle, TableSubtitle } from './styles'
import { ResultsProps } from './types'

export function Results({ description, cards }: ResultsProps) {
  return (
    <Wrapper>
      <Description {...description} />
      <Cards>
        {cards.map(({ title, subtitle }) => (
          <Card key={title}>
            <TableTitle as="h3">{title}</TableTitle>
            <TableSubtitle>{subtitle}</TableSubtitle>
          </Card>
        ))}
      </Cards>
    </Wrapper>
  )
}
